import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

import { LicenseManager } from 'ag-grid-enterprise';
LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-095410}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyota}_is_granted_a_{Multiple_Applications}_Developer_License_for_{5}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{7}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{18_January_2027}____[v3]_[01]_MTgwMDIzMDQwMDAwMA==46ac1b6b703b45287199e386ca8d5f25");

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.info(err)); // NOSONAR
